export const serviceMenu = [
    { id: 0, name: "场地验收", link: "/service/certification?id=0"},
    { id: 1, name: "面层审定", link: "/service/certification?id=1"},
    { id: 2, name: "芯片审定", link: "/service/certification?id=2"},
    { id: 3, name: "器材审定", link: "/service/certification?id=3"},
    { id: 4, name: "步道审定", link: "/service/certification?id=4"},
    { id: 5, name: "培训&注册", link: "/service/certification?id=5"},
    { id: 6, name: "咨询服务", link: "/service/certification?id=6"},
    { id: 7, name: "名录查询", link: "/directoryMore"},
    { id: 8, name: "相关书籍", link: "/service/books?id=8"},
    { id: 9, name: "奖座及证书", link: "/service/books?id=9"}
];